import Service from '../../sdk/services/Service';
import AuthService from './Authorization.service';
import { isPublicAuthRoute, readApiError } from '../../sdk/errors/apiError';
import { denialCopy } from '../../sdk/errors/denialCopy';
import { notifyDenial } from '../components/AccessDenied/notifyDenial';

Service.setRequestInterceptors(async (request) => {

  const storage = {
    accessToken: AuthService.getAccessToken(),
  }

  const {accessToken} = storage;

  // injeta o token de acesso na requisição
  if (accessToken) {
    request.headers['Authorization'] = `Bearer ${accessToken}`;
  }

  return request;
});

/**
 * Todo erro da API passa por aqui e é lido uma vez só (`readApiError`). Quando
 * é negativa de permissão, o usuário recebe a mensagem certa sem que cada tela
 * precise tratar 401/403 na mão; o erro segue rejeitado, com `apiError` anexado,
 * para quem quiser mostrar o bloqueio no lugar do conteúdo.
 */
Service.setResponseInterceptors(
  (response) => response,
  async (error) => {
    const apiError = readApiError(error);

    // Rotas públicas de credencial ficam de fora: um 401 em /auth/login é senha
    // errada, e essas telas mostram o erro no próprio formulário. Deslogar aqui
    // recarregaria a página de login no meio da tentativa de login.
    if (isPublicAuthRoute(error?.config?.url)) {
      return Promise.reject(Object.assign(error, { apiError }));
    }

    switch (apiError.kind) {
      case 'unauthenticated':
      case 'session-expired':
        // Login.view.tsx lê esta chave e mostra o texto acima do formulário —
        // guardamos a copy amigável, não a string crua do Go.
        window.localStorage.setItem('errorMessage', denialCopy[apiError.kind].title);
        AuthService.logoutAndRedirect();
        // Promise que nunca assenta. A versão anterior fazia `return;`, que
        // resolvia com `undefined` e fazia todo `.then(this.getData)` a jusante
        // quebrar durante o redirecionamento.
        return new Promise(() => {});

      // Assinatura vencida chega como 401 (middleware.go:161-217), mas NÃO é
      // falha de autenticação: a sessão é válida, o plano é que não cobre.
      // Deslogar aqui expulsava justamente quem só precisava renovar.
      case 'subscription':
      case 'admin-only':
      case 'ownership':
      case 'forbidden':
      case 'readonly-key':
      case 'rate-limited':
      case 'email-not-verified':
        notifyDenial(apiError);
        break;

      default:
        break;
    }

    return Promise.reject(Object.assign(error, { apiError }));
});
